// extracted by mini-css-extract-plugin
module.exports = {"timeline":"styles_timeline__1TFes"};